import {Component, Input} from '@angular/core';

//Composant panneau d’information
//  Encart vert à icône « information » qui explique un paramétrage délicat : à quoi sert le réglage,
//  comment le saisir, avec des exemples. C’est le style normalisé de la plateforme pour ce besoin
//  (SU #120940) : l’employer plutôt qu’un libellé d’aide posé sous un champ ou qu’un bandeau ad hoc.
//  Le contenu est projeté : paragraphes, listes à puces et <code> y sont mis en forme par le composant.
//  Ne pas y faire passer par le pipe val_markdown un texte qui contient des expressions régulières :
//  le pipe convertit les * en italique et les mutile.
//  Exemple
//    <val-panneau-information [titre]="'cle.titre' | transloco">
//      <p>{{ 'cle.explication' | transloco }}</p>
//      <ul><li><code>^\s*$</code> {{ 'cle.champ-vide' | transloco }}</li></ul>
//    </val-panneau-information>
@Component (
{
  selector: 'val-panneau-information',
  imports:
  [
  ],
  templateUrl: './panneau-information.component.html',
  styleUrl: './panneau-information.component.scss'
})
export class PanneauInformationComponent
{
  //Création
  constructor ()
  {
    this.titre = "";
  }

  //Titre affiché en tête du panneau, facultatif
  @Input ()
  public titre: string;
}
